"use client";

import { usePathname } from "next/navigation";
import { ReactNode } from "react";

type SessionSectionProps = {
  children: ReactNode;
};

export default function SessionSection({ children }: SessionSectionProps) {
  const pathname = usePathname();
  const isProfileJobsPage =
    pathname.includes("/profiles/") && pathname.includes("/jobs");

  if (isProfileJobsPage) {
    return null;
  }

  return <>{children}</>;
}
